import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import config from '@/config'

const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: title + '-产品信息'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品信息丨水利信息化咨询'
              }
            },
            {
              path: '/software/punmControl',
              name: 'software',
              component: resolve => require(['@/view/Software_punmControl'], resolve),
              meta: {
                title: '产品信息丨闸泵远程控制系统'
              }
            },
            {
              path: '/software/forecast',
              name: 'software',
              component: resolve => require(['@/view/Software_forecast'], resolve),
              meta: {
                title: '产品信息丨水文自动测报系统'
              }
            },
            {
              path: '/software/irrigate',
              name: 'software',
              component: resolve => require(['@/view/Software_irrigate'], resolve),
              meta: {
                title: '产品信息丨智能化微喷灌'
              }
            },
            {
              path: '/software/environment',
              name: 'software',
              component: resolve => require(['@/view/Software_environment'], resolve),
              meta: {
                title: '产品信息丨水环境监测'
              }
            },
            {
              path: '/software/waterlogging',
              name: 'software',
              component: resolve => require(['@/view/Software_waterlogging'], resolve),
              meta: {
                title: '产品信息丨城市内涝监测'
              }
            },
            {
              path: '/software/dams',
              name: 'software',
              component: resolve => require(['@/view/Software_dams'], resolve),
              meta: {
                title: '产品信息丨大坝安全监测'
              }
            },
            {
              path: '/software/video',
              name: 'software',
              component: resolve => require(['@/view/Software_video'], resolve),
              meta: {
                title: '产品信息丨视频安防系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '产品信息丨数据中心建设'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: title + '-相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-发展历程'
          }
        }, {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: title + '-企业荣誉'
          },children: [
            {
              path: '/jobchance',
              redirect: '/jobchance/company'
            },
            {
              path: '/jobchance/patent',
              name: 'jobchance',
              component: resolve => require(['@/view/JobChance_patent'], resolve),
              meta: {
                title: '企业荣誉丨发明专利'
              }
            },
            {
              path: '/jobchance/work',
              name: 'jobchance',
              component: resolve => require(['@/view/JobChance_work'], resolve),
              meta: {
                title: '企业荣誉丨软件著作'
              }
            },
            {
              path: '/jobchance/company',
              name: 'jobchance',
              component: resolve => require(['@/view/JobChance_company'], resolve),
              meta: {
                title: '企业荣誉丨企业资质'
              }
            },
          ]
        },  {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: title + '-相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js